import React, { useCallback, useState } from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import DisplayTransition from '../../../../../../desktop/components/transitions/display-transition'
import Mask from '../../../../../../desktop/components/mask'
import { BigButton } from '../../../../../../components/button'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { useHistory } from 'react-router-dom'
import Cache from '../../../../../../../utils/cache'
import { useApp } from '../../../../../../hooks/common'
import { useSelector } from 'react-redux'
import { __Pay_Ebanx__, __Pay_Ebanx_Debet__ } from '../../../../../../../utils/paymethods'

const ErrorDisplay = props => {
    useStyles(classes)
    const { orderId, error, onClose, onDeco, redirectType } = props
    const { message, payMethod, noticeType, redirectPayMethod, deco } = error || {}
    const history = useHistory()
    const global = useSelector(state => state.global)
    const isApp = useApp()

    const trachError = useCallback((method, clicks) => {
        // try {
        //     const count = Cache.get('credit-pay-count') || 1
        //     if (window.GeekoSensors) {
        //         window.GeekoSensors.Track('PayOrderFail', {
        //             pay_method: method,
        //             pay_now: count,
        //             clicks
        //         })
        //     }
        // } catch (e) {
        //     console.error(e)
        // }
    }, [])

    const switchHandle = useCallback(e => {

        trachError(payMethod, 'switch_method')

        if (isApp) {
            window.location.href = `/geekopay/app-fail?selectPayment=1&noticeType=${noticeType}`
        } else {
            if (redirectType === 'order') {
                window.location.href = `/checkout/${orderId}?selectPayment=1`
            } else {
                history.push(`/cart/checkout?selectPayment=1`)
            }
        }
    }, [payMethod])

    const changeCardHandle = useCallback(e => {

        trachError(payMethod, 'change_card')

        if (redirectPayMethod) {
            if(redirectPayMethod === __Pay_Ebanx__ || redirectPayMethod === __Pay_Ebanx_Debet__){
                window.location.href = `/cart/credit/${orderId}?payMethod=${redirectPayMethod}`
            }else{
                history.push(`/cart/credit-card/${orderId}?payMethod=${redirectPayMethod}`)
            }
        } else if (deco && deco.decoStatus === 'eligible') {
            onDeco(deco)
        }

        onClose()
    }, [redirectPayMethod, payMethod])


    return <div className={classes.ErrorDisplay}>
        <div className={classes.Content}>{message}</div>
        <div className={classes.Buttons}>
            <BigButton className={classes.Button} outlined={noticeType !== '2'} onClick={switchHandle} style={{
                order: noticeType === '2' ? 1 : 2
            }}>
                <FormattedMessage id="switch_payment_method" defaultMessage="Switch Payment Method" />
            </BigButton>
            <BigButton className={classes.Button} outlined={noticeType === '2'} onClick={changeCardHandle} style={{
                order: noticeType === '2' ? 2 : 1
            }}>
                <FormattedMessage id="change_card_information" defaultMessage="Change Card Information" />
            </BigButton>
        </div>
        <Iconfont className={classes.Close} onClick={onClose}>&#xe7bc;</Iconfont>
    </div>
}

const WrappedEditor = props => {
    useStyles(classes)

    return <React.Fragment>
        <DisplayTransition in={props.show} className={classes.Container}>
            <div>
                <ErrorDisplay {...props} />
            </div>
        </DisplayTransition>
        {props.show && <Mask style={{
            zIndex: 50
        }} onClick={props.onClose} />}
    </React.Fragment>
}


export default props => {

    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <WrappedEditor {...props} />,
        document.getElementById('root')
    )
}